import React, { useState, useMemo, useEffect } from 'react';
import LayoutMain_Bus from "../LayoutMain_Bus/LayoutMain_Bus";
import Mileagesaarathi_two from './MileageSarathiTab_bus/MileageSaarathiTab'; // Import the new component
import styles from "./MileageSarathi.module.css"
import './style.css'
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates_bus';
import useHttp from '../../../hook/use-http';
import MileageAnalysisTab from './MileageAnalysisTab_bus/MileageAnalysisTab';
import GrowthTrackingTab from './GrowthTrackingTab_bus/GrowthTracking';
import MileageSimulatorTab from './MileageSimulatorTab/MileageSimulatorTab';
import MultivariateAnalysisTab from './MultivariateAnalysisTab_bus/MultivariateAnalysisTab';
import Overview from './Overview_Tab_bus/Overview';
import { VehicleDataProvider } from './MileageAnalysisTab_bus/context';
import RangeAnalysisTab from './RangeAnalysisTab_bus/RangeAnalysisTab_bus';
import { RangeAnalysisProvider } from './RangeAnalysisTab_bus/Context'
import { MultivarientProvider } from './MultivariateAnalysisTab_bus/context';
import { useLocation } from 'react-router-dom';

function Mileagesaarathi_bus() {
  const [activeTab, setActiveTab] = useState('Mileage Saarathi');
  const { isLoading, error, sendReq: fetchData } = useHttp();

  useEffect(() => {
    fetchData({
      url: API_URL_MAIN + "auth/logging", body: {
        page_name: "Mileage Saarathi"
      }
    })
  }, [])

  const tabs = [
    'Overview',
    'Mileage Saarathi',
    'Mileage Analysis',
    'Range Analysis',
    'Growth Tracking',
    'Mileage Simulator',
    'MS - Multivariate Analysis'
  ];

  return (
    <LayoutMain_Bus>
      <div className={`${styles.bg_screen}`}>
        <div className={`mb-3 card ${styles.bg_screen2}`}>
          <div className="col-12">
            <div className={`nav ${styles.tabs}`}>
              {tabs.map((tab) => (
                <div key={tab} className='mx-1'>
                  <button
                    className={`${styles.nav_bar_buttons} ${activeTab === tab ? styles.tab_bar : ''}`}
                    onClick={() => setActiveTab(tab)}
                  >
                    {tab}
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Render content based on the active tab */}
        {activeTab === 'Overview' && (
          <Overview />
        )}

        {activeTab === 'Mileage Saarathi' && (
          <Mileagesaarathi_two /> // Render the new component
        )}
        {activeTab === 'Mileage Analysis' && (
          <VehicleDataProvider>
            <MileageAnalysisTab />
          </VehicleDataProvider>
        )}

        {activeTab === 'Range Analysis' && (
          // <></>
          <RangeAnalysisProvider>
            <RangeAnalysisTab />
          </RangeAnalysisProvider>
        )}
        {activeTab === 'Growth Tracking' && (
          <GrowthTrackingTab /> // Render the new component
        )}
        {activeTab === 'Mileage Simulator' && (
          <MileageSimulatorTab /> // Render the new component
        )}
        {activeTab === 'MS - Multivariate Analysis' && (
          <MultivarientProvider>
            <MultivariateAnalysisTab />
          </MultivarientProvider>
        )}
      </div>
    </LayoutMain_Bus>
  );
}

export default Mileagesaarathi_bus;